import React, { useContext } from 'react';
import { NetworkContext } from '@/contexts/network/NetworkGuard';

export default function NetworkHealthPrompt() {
  const { showHealthPrompt, healthUrl, dismiss, retryLast } = useContext(NetworkContext);
  if (!showHealthPrompt) return null;

  const openHealth = () => {
    window.open(healthUrl, '_blank', 'noopener');
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000
    }}>
      <div style={{ background: '#111827', color: '#fff', padding: 20, borderRadius: 8, width: 420, boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
        <h3 style={{ marginTop: 0, marginBottom: 10 }}>Connection blocked by browser</h3>
        <p style={{ marginTop: 0, opacity: 0.9 }}>
          Your browser blocked requests to the backend due to missing SSL or CORS.
          Please open the backend health endpoint, proceed to trust it, then retry.
        </p>
        <div style={{ display: 'flex', gap: 8, marginTop: 16, justifyContent: 'flex-end' }}>
          <button onClick={dismiss} style={{ padding: '8px 12px', background: '#374151', color: '#fff', border: 0, borderRadius: 6 }}>Dismiss</button>
          <button onClick={openHealth} style={{ padding: '8px 12px', background: '#2563eb', color: '#fff', border: 0, borderRadius: 6 }}>Open Health</button>
          <button onClick={retryLast} style={{ padding: '8px 12px', background: '#10b981', color: '#0b1722', border: 0, borderRadius: 6, fontWeight: 600 }}>Retry</button>
        </div>
        <div style={{ marginTop: 10, fontSize: 12, opacity: 0.8, wordBreak: 'break-all' }}>
          Health URL: {healthUrl}
        </div>
      </div>
    </div>
  );
}

